import React from 'react';
import {OffersDataStyled} from "../../../styled/HomeContent";
import {useTheme} from "../Theme/ThemeContext";
import Button from "../Buttons/Button";
import { FaArrowRight } from "react-icons/fa";
import Blob from "../Blob/Blob";
import {Link} from "react-router-dom";
import analyticsTracker from "../../../utils/analytics";

const RenderOfferData = ({data, isAuth}) => {
    const { themeName } = useTheme();
    return (
        <>
        {
            data && data.map((item, index)=>(
                <OffersDataStyled key={index} theme={themeName}>
                    <h2>{item.title}</h2>
                    <Blob
                      link={isAuth ? item.isAuthURL : item.unAuthURL}
                      bgImage={item.image}
                      altText={item.title}
                      desc={item.desc}
                      title={item.title}
                    />
                    <p>{item.desc}</p>
                    <div className="link">
                        <Link to={item.learn}>How I Work</Link>
                    </div>

                    { themeName === "dark" &&

                        <Button
                            width="90%"
                            link={isAuth ? item.isAuthURL : item.unAuthURL}
                            secondary={true}
                            title={item.action}
                            clickHandle={() => analyticsTracker.trackServiceClick(item.title, isAuth ? item.isAuthURL : item.unAuthURL)}
                        >

                            <FaArrowRight />
                        </Button>
                    }
                    {
                        themeName === "light" &&
                            <Button
                                width="90%"
                                link={isAuth ? item.isAuthURL : item.unAuthURL}
                                secondaryLight={true}
                                title={item.action}
                                clickHandle={() => analyticsTracker.trackServiceClick(item.title, isAuth ? item.isAuthURL : item.unAuthURL)}
                            >

                                <FaArrowRight />
                            </Button>
                    }
                </OffersDataStyled>
            ))

        }
         </>

    );
}

export default RenderOfferData;